import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SideNavService {
    private readonly _menuOpen = new BehaviorSubject<boolean>(true);

    constructor() {}

    public toggleMenu() {
        this._menuOpen.next(!this._menuOpen.value);
    }
    get menuOpen() {
        return this._menuOpen.value;
    }

    get menuOpen$() {
        return this._menuOpen.asObservable();
    }

    public closeMenu(): void {
        this._menuOpen.next(false);
    }

    public openMenu(): void {
        this._menuOpen.next(true);
    }
}
